import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative overflow-hidden text-center" style={{
    paddingTop: 'var(--pad-section-y)',
    paddingBottom: 'var(--space-section-lg)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-76">
          <span className="inline-block py-1 px-3 rounded-full bg-[#A52422]/10 border border-[#A52422]/20 text-[#A52422] font-medium tracking-widest uppercase fluid-xs text-[9px]" style={{
          marginBottom: '1.2em'
        }} data-id="element-77">
            Para mujeres que quieren recuperar su dignidad
          </span>

          <h1 className="fluid-hero font-bold text-white leading-[1.1] tracking-tight" style={{
          marginBottom: '1.2em'
        }} data-id="element-78">
            No Le Escribas: <br data-id="element-79" />
            <span className="text-[#A52422] italic font-serif" data-id="element-80">
              Contacto Cero
            </span>{' '}
            en 7 Días
          </h1>

          <p className="fluid-subtitle text-[#F5F0EB]/90 font-serif italic max-w-2xl mx-auto leading-relaxed" style={{
          marginBottom: '1.2em'
        }} data-id="element-81">
            Protocolo Anti‑Espiral para la primera semana después de una ruptura
          </p>

          <p className="fluid-base text-[#9A948C] max-w-xl mx-auto text-[14px]" style={{
          marginBottom: '1.5em'
        }} data-id="element-82">
            Cuando el móvil te quema en la mano y tu cabeza inventa excusas,
            esto te dice exactamente qué hacer hoy.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mx-auto w-[65%] max-w-[340px]" style={{
        marginBottom: '1.5em'
      }} data-id="element-83">
          <div className="absolute -inset-4 bg-[#A52422]/20 blur-3xl rounded-full opacity-40 animate-pulse" data-id="element-84" />
          <img src="https://cdn.magicpatterns.com/uploads/9hKtgqhqQ9ywofceBUfJBz/heylloyd-image-1771269867266.png" alt="No Le Escribas - Guía Digital en Tablet" className="relative z-10 w-full drop-shadow-2xl rounded-lg" style={{
          maxWidth: '100%',
          height: 'auto',
          objectFit: 'contain'
        }} data-id="element-85" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-86">
          <CTAButton className="mx-auto" data-id="element-87" />
          <p className="text-[#9A948C] uppercase tracking-widest fluid-xs" style={{
          marginTop: '1em'
        }} data-id="element-88">
            Descarga inmediata • Acceso de por vida
          </p>
        </motion.div>
      </div>
    </section>;
}